import { LoginContainer } from "./LoginContainer";

export interface ILoginProps {
  appName: string;
  appIcon?: JSX.Element;
  systemName: string;
  userRole?: string;
  enableRoles?: boolean;
  userSupervisorRole?: string;
  handleConfirmOk: (props: ILoginResponse) => void;
  handleConfirmFail: () => void;
  handleExit: () => void;
}

export interface ILoginResponse {
  isSupervisor: boolean;
  user: string;
  password: string;
}

export const Login = (props: ILoginProps): JSX.Element => {
  //console.log("LoginContainer", props);
  return (
    <LoginContainer
      appName={props.appName}
      appIcon={props.appIcon}
      systemName={props.systemName}
      userRole={props.userRole}
      enableRoles={props.enableRoles}
      userSupervisorRole={props.userSupervisorRole}
      handleConfirmOk={props.handleConfirmOk}
      handleConfirmFail={props.handleConfirmFail}
      handleExit={props.handleExit}
    />
  );
};

export default Login;
